import { useEffect, useState } from "react";
import "./editRacks.css";
import { UseOnChange } from "../../utils/onChange";
import { ButtonLess } from "../button/buttonLess";
import { Input } from "../input/input";
import { Button } from "../button/button";
import Chevron from './img/Chevron White.svg'
import { useStore } from "../../store/useStore";

export function EditRacks(props) {
    const { onChange, values, setValues } = UseOnChange()
    const { clientsData } = useStore()

    // CLIENT SEARCH
    const [showInputClient, setShowInputClient] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [clientListInitial , setClientListInitial] = useState(clientsData);   
    const [isInputDisabled, setIsInputDisabled] = useState(false);

    // SEARCH CLIENT
    let clientListFiltered = []
    const lowerSearch = inputValue.toLowerCase();
    clientListFiltered = clientListInitial.filter((element) =>
        element.client.client.toLowerCase().includes(lowerSearch))

    useEffect(() => {
        if(inputValue != ""){
            setShowInputClient(true)
        } else {
            setShowInputClient(false)
        }
    }, [inputValue])

    // STATUS SELECT
    const [selectStatus, setSelectStatus] = useState(props.values.reserved ? "reserved" : props.values.status ? "added" : props.values.status == false ? "churned" : "churned");
    // const [showStatusDropdown, setShowStatusDropdown] = useState(false)

    // async function sendRackStatus(status){
    //     setShowStatusDropdown(false)
    //     setSelectStatus(status)
    //     props.setEditObj(status == 'added' ? { ...props.values, status: true , reserved: false} : status == 'churned' ? { ...props.values, status: false , reserved: false} : status == 'reserved' ? { ...props.values, status: true, reserved: true } : { ...props.values, status: false , reserved: false});
    // };

    // change client to "AVAILABLE RACK" if status == "churned" and lock the client input search
    useEffect(() => {
        if(selectStatus == "churned"){
            props.setEditObj({...props.values, 
                client: {
                    id: '76AB50F4-6204-49ED-8613-7307EBC2E18A',
                    client: "AVAILABLE RACK",
                    createdAt: "2024-01-01 00:00:00.000",
                    updatedAt: "2024-01-01 00:00:00.000"
                }, 
                clientName: "AVAILABLE RACK"})
            setInputValue("AVAILABLE RACK")
            setTimeout(() => {
                setShowInputClient(false)
            }, 50)
            setIsInputDisabled(true);
        } else {
            setIsInputDisabled(false);
        }
    }, [selectStatus])
    

    const onButtonClick = () => {
        const newPdus = [{ name: values.name, circuito: values.circuito }, ...props.pdus];
        props.setPdus(newPdus);
        setValues({ ...values, name: '', circuito: '' });
    };

    return (
        <section className="edit-racks-body">
            <div style={{ width: '80%', padding: 20, background: '#fff' }} className="addedsrows">
                <div style={{ display: 'flex', flexDirection: 'column', padding: 20, gap: 10 }}>

                    {/* <div className="row-select-client-status">
                        <div className="row-select-client">
                            <p>Client Select</p>
                            <input 
                                id="client-select"
                                type="text" 
                                onChange={(e) => setInputValue(e.target.value)} 
                                value={inputValue} 
                                placeholder={props.values.client.client != "" ? props.values.client.client : "Search client by name"}
                                disabled={isInputDisabled}
                            />
                            {
                                showInputClient ?
                                    <div className="row-select-client-dropdown">
                                        {clientListFiltered.map((client) => {
                                            return (
                                                <p onClick={() => (
                                                    props.setEditObj({...props.values, client: client.client, clientName: client.client.client}),
                                                    setInputValue(client.client.client),
                                                    setTimeout(() => {
                                                        setShowInputClient(false)
                                                    }, 50)
                                                )}>{client.client.client}</p>
                                            )
                                        })}
                                    </div>
                                :
                                    <></>
                            }
                        </div>

                        
                        <div className="row-select-status">
                            <div className="row-select-status-select">
                                <p>Status select</p>
                                <div onClick={() => setShowStatusDropdown(!showStatusDropdown)} className="row-select-status-select-input">
                                    <input 
                                        type="text" 
                                        style={selectStatus == "added" ? {backgroundColor:"#59975C"} : selectStatus == "churned" ? {backgroundColor:"#B73D3D"} : {backgroundColor:"#E89F17"}}
                                        name="select-status" 
                                        id="select-status-id" 
                                        value={selectStatus}/>
                                    <img 
                                        src={Chevron} 
                                        style={showStatusDropdown ? {transform: "rotate(270deg)"} : {transform: "rotate(90deg)"}} 
                                        
                                        alt="icone do botão para selecionar o status do rack" />
                                </div>
                            </div>

                            {
                                showStatusDropdown ?
                                <div className="row-select-status-dropdown">
                                    <p onClick={() => sendRackStatus("added")} style={{backgroundColor:"#59975C"}} value="added">added</p>
                                    <p onClick={() => sendRackStatus("churned")} style={{backgroundColor:"#B73D3D"}} value="churned">churned</p>
                                    <p onClick={() => sendRackStatus("reserved")} style={{backgroundColor:"#E89F17"}} value="reserved">reserved</p>
                                </div>
                                :
                                <></>
                            }
                        </div>
                    </div> */}

                    <div className="row-inputs-technical-added">
                        <Input
                            onChange={props.onChange}
                            name="nrack"
                            required
                            value={props.values.nrack}
                            placeholder='0000'
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Client Rack Name"}
                            type="text"
                        />
                        <Input
                            onChange={props.onChange}
                            name="nscala"
                            required
                            placeholder='0000'
                            value={props.values.nscala}
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Scala Rack Name"}
                            type="text"
                        />
                        <Input
                            onChange={props.onChange}
                            name="potenciaContratada"
                            required
                            placeholder='0'
                            value={props.values.potenciaContratada}
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Power"}
                            type="text"
                        />
                        <Input
                            onChange={props.onChange}
                            name="fileira"
                            required
                            placeholder='Ex: 1'
                            value={props.values.fileira}
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Row - Y axis"}
                            type="number"
                        />
                        <Input
                            onChange={props.onChange}
                            name="posicao"
                            required
                            placeholder='Ex: 1'
                            value={props.values.posicao}
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Position - X axis"}
                            type="number"
                        />
                        <Input
                            onChange={props.onChange}
                            name="ocupacao"
                            placeholder='600x1050x44U'
                            value={props.values.ocupacao}
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Occupation"}
                            type="text"
                        />
                        <Input
                            onChange={props.onChange}
                            name="classification"
                            placeholder='Ex: Scala / Edge'
                            value={props.values.classification}
                            props={{
                                minWidth: "unset",
                                marginRight: 10,
                            }}
                            title={"Classification"}
                            type="text"
                        />
                    </div>
                    <div style={{ display: 'flex', gap: 15, alignItems: 'center', width: '100%' }} >
                        <Input
                            onChange={onChange}
                            name="name"
                            required
                            value={values.name}
                            placeholder='PDU A.A'
                            props={{
                                minWidth: "unset",
                            }}
                            style={{ width: '50%' }}
                            title={"PDU"}
                            type="text"
                        />
                        <Input
                            onChange={onChange}
                            name="circuito"
                            required
                            value={values.circuito}
                            placeholder='0.0.0.0'
                            props={{
                                minWidth: "unset"
                            }}
                            style={{ width: '50%' }}
                            title={"Circuit"}
                            type="text"
                        />
                        <ButtonLess
                            disabled={!values.name || !values.circuito}
                            style={{ marginTop: 17, }} onClick={values.name || values.circuito ? () => onButtonClick() : null}
                            type='plus' />

                    </div>

                    <div >
                        {
                            !!props.pdus &&
                            props.pdus?.map((pdu, indPdu) => {
                                return (
                                    <div style={{ display: 'flex', gap: 15, alignItems: 'center', width: '100%' }} key={indPdu}>
                                        <Input
                                            disabled
                                            value={pdu.name}
                                            props={{
                                                border: 'none',
                                                background: 'transparent',

                                                minWidth: "unset",
                                            }}
                                            style={{ width: '50%' }}
                                            title={"PDU/SDU"}
                                        />
                                        <Input
                                            disabled
                                            value={pdu.circuito}
                                            props={{
                                                border: 'none',
                                                background: 'transparent',

                                                minWidth: "unset",
                                            }}
                                            style={{ width: '50%' }}
                                            title={"Circuit"}
                                        />
                                        <ButtonLess onClick={() => {
                                            const newValue = props.pdus?.filter(el => el.name !== pdu.name && el.circuito === pdu.circuito)
                                            props.setPdus(newValue);
                                        }} type='x' />
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ display: 'flex', gap: 10, width: '100%' }}>
                        <Button onClick={() => { props.setEditObj({}); return props.setPdus([]) }} label='Cancel' />
                        <Button disabled={((values.name && values.circuito) && props.pdus.length < 1)} onClick={props.save} label='Save' />
                    </div>
                </div>
            </div>
        </section>
    )
}